module.exports = __webpack_public_path__ + "img/temperature-thermometer-white.f766cd0b.svg";